module.exports = __webpack_public_path__ + "static/media/logo-1@2x.8da5f4a3.png";